module.exports = __webpack_public_path__ + "fonts/Lato-Light.4afee4c9.eot";